import React, { createContext, useState, useEffect } from 'react'
import { auth, db } from '../../Firebase/firebase'

export const AuthContext = createContext()


export const AuthProvider = ({children}) => {


  const [currentUser, setCurrentUser] = useState('')

  const signUp = async(email,password,displayName) => {
    auth.createUserWithEmailAndPassword(email,password)
      .then(cred => {
        cred.user.updateProfile({
          displayName,
          photoURL: "https://st3.depositphotos.com/4111759/13425/v/600/depositphotos_134255532-stock-illustration-profile-placeholder-male-default-profile.jpg"
        })
        console.log("signed in")
        db.collection('users').doc(cred.user.uid).set({
          userName: displayName,
          profilePic: "https://st3.depositphotos.com/4111759/13425/v/600/depositphotos_134255532-stock-illustration-profile-placeholder-male-default-profile.jpg",
          bio:""
        })
      })
    .catch(err => alert(err.message))
  }

  const logIn = async(email,password) => {
    await auth.signInWithEmailAndPassword(email,password)
    .catch(err => alert(err.message))
  }

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged(user => {
      setCurrentUser(user)
    })

    return unsubscribe
  }, [])



  return(
    <AuthContext.Provider value={
      {
        currentUser,
        signUp,
        logIn
      }
    }>
      {children}
    </AuthContext.Provider>
  )
}